import { getHublet } from '../store/app/selectors';
import { isPortalIdDefined } from '../store/auth/selectors';
import { isNewLoggedInAccount } from './endpointStateChecks';
import { EndpointKey } from './EndpointKey';
import { getIsActiveAndAssignedToVariant, getParameter } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import Logger from '../lib/Logger';
import { getSentryExtra } from '../error/getSentryExtra';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { writeHubUserAttribute } from '../utils/hubUserAttribute';
import { Tracker } from '../store/tracking/action-creators';
const ACQ0149_TREATMENT_HUB_USER_ATTRIBUTE_KEY = 'GrowthOnboardingSetup:ACQ0149NewSignupOnboardingFlowTreatment';
const storeACQ0149Treatment = state => {
  const hublet = getHublet(state);
  const acq0149Treatment = getParameter(state, ExperimentKeys.ACQ0149);
  return writeHubUserAttribute(ACQ0149_TREATMENT_HUB_USER_ATTRIBUTE_KEY, acq0149Treatment, hublet);
};
export const LOG = Logger.getLogger('storeACQ0149TreatmentError');
export const EndpointsStoreACQ0149Treatment = {
  [EndpointKey.StoreACQ0149Treatment]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state =>
    // Is the Portal created so we can use the Hub User Attributes API?
    isPortalIdDefined(state) &&
    // Is the user in the ACQ0149 experiment?
    getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0149, [ExperimentParameterGroup.Control, ExperimentParameterGroup.Variant_A]) &&
    // Is the user authed for API usage?
    isNewLoggedInAccount(state),
    method: storeACQ0149Treatment,
    handleSuccess: (response, dispatch) => {
      dispatch(Tracker.signupInteraction('success-store-acq0149-treatment'));
    },
    handleError: (error, dispatch, getState) => {
      dispatch(Tracker.signupInteraction('error-store-acq0149-treatment'));
      const numberOfStoreTreatmentRetries = getEndpointRetries(getState(), EndpointKey.StoreACQ0149Treatment);
      LOG.error('Storing ACQ0149 treatment error', {
        extra: Object.assign({}, getSentryExtra(error), {
          totalNumberOfCalls: numberOfStoreTreatmentRetries
        })
      });
      // Retry every second, up to 5 times
      if (numberOfStoreTreatmentRetries < 5) {
        dispatch(Tracker.signupInteraction('retry-store-acq0149-treatment', {
          totalNumberOfCalls: numberOfStoreTreatmentRetries
        }));
        dispatch(retryEndpoint(EndpointKey.StoreACQ0149Treatment, 1000));
      }
    }
  }
};